import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListInfoComponent } from './list-info.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ ListInfoComponent ],
    declarations: [ ListInfoComponent ],
    entryComponents: [ ListInfoComponent ],
})
export class ListInfoModule {}
